import { ProductContext } from '../App.d'

const getProductFromPort = (port: string): ProductContext => {
	switch (port) {
		case '5003':
			return 'subsync'
		case '5002':
			return 'tayg'
		case '5001':
			return 'leavecal'
		case '5000':
		default:
			return 'oversight'
	}
}

const productContext =
	window.location.hostname !== 'localhost'
		? (window.location.hostname.split('.')[0].replace('-dev', '') as ProductContext)
		: getProductFromPort(window.location.port)

const productNameFromContext = (context: ProductContext) => {
	switch (context) {
		case 'leavecal':
			return 'LeaveCal'
		case 'oversight':
			return 'Oversight'
		case 'subsync':
			return 'SubSync'
		case 'tayg':
			return 'TAYG'
	}
}

export { productContext, getProductFromPort, productNameFromContext }
